var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgConsoleArrow = function SvgConsoleArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.638 5.294-2.976-3.072-.032-.036c-.026-.033-.034-.041-.057-.077-.215-.339-.077-.862.282-1.038a.67.67 0 0 1 .227-.066c.09-.01.112-.002.141 0a.726.726 0 0 1 .349.141c.033.027.04.035.07.065l4.159 4.292c.029.032.036.04.062.073a.751.751 0 0 1 0 .865c-.026.035-.033.042-.062.074l-4.158 4.292c-.031.03-.038.038-.071.064-.37.29-1.016.07-1.102-.448a.742.742 0 0 1 .13-.554c.026-.035.034-.042.062-.073l2.976-3.072H1.678c-.056-.007-.112-.007-.166-.02-.478-.123-.714-.845-.294-1.23a.686.686 0 0 1 .294-.16c.054-.013.11-.013.166-.02h14.96Z",
    fill: "#212121",
    stroke: "#FFF",
    strokeWidth: 0.4,
    fillRule: "evenodd"
  })));
};
export default SvgConsoleArrow;